import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { SalesComponent } from './components/sales/sales.component';
import { EventSalesComponent } from './components/event-sales/event-sales.component';
import { CalendarSalesComponent } from './components/calendar-sales/calendar-sales.component';
import { SubscriptionComponent } from './components/subscription/subscription.component';
import { StatementComponent } from './components/statement/statement.component';
import { BuyerInfoComponent } from './components/buyer-info/buyer-info.component';
import { QassatlyRepaymentsComponent } from './components/qassatly-repayments/qassatly-repayments.component';
import { AuthGuardService as AuthGuard } from '../../../shared/services/auth.guard';
import { PermissionsGuardService } from '../../../shared/services/permissions-guard.service';
import { BuyerInfoDetailsComponent } from './components/buyer-info-details/buyer-info-details.component';
import { SmsMarketingComponent } from './components/sms-marketing/sms-marketing.component';
import { CreateMarketingSmsComponent } from './components/sms-marketing/create-marketing-sms/create-marketing-sms.component';
import { MonthlyInvoiceComponent } from './components/monthly-invoice/monthly-invoice.component';
import { isQassatlyMerchantGuard } from './services/isQassatlyMerchantGuardService.guard';
import { ReservationSalesComponent } from './components/reservation-sales/reservation-sales.component';
import { TransactionsDetailComponent } from './components/transactions-detail/transactions-detail.component';

const reportRoutes: Routes = [
  { path: 'sales', component: SalesComponent },
  { path: 'sms-marketing', component: SmsMarketingComponent },
  { path: 'create-marketing-sms', component: CreateMarketingSmsComponent },
  { path: 'eventSales', component: EventSalesComponent },
  { path: 'reservationSales', component: ReservationSalesComponent },
  { path: 'calendarSales', component: CalendarSalesComponent },
  { path: 'subscription', component: SubscriptionComponent },
  { path: 'transactionsDetail', component: TransactionsDetailComponent },
  {
    path: 'qassatlyRepaymentsReports',
    component: QassatlyRepaymentsComponent,
    canActivate: [isQassatlyMerchantGuard]
  },
  {
    path: 'statement',
    component: StatementComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
  {
    path: 'buyerInfoReport',
    component: BuyerInfoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "buyerInfoReport/details/:id",
    component: BuyerInfoDetailsComponent,
    canActivate: [AuthGuard]
  },
    {
    path: 'monthly-invoice',
    component: MonthlyInvoiceComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [
    SalesComponent,
    EventSalesComponent,
    CalendarSalesComponent,
    SubscriptionComponent,
    StatementComponent,
    BuyerInfoComponent,
    QassatlyRepaymentsComponent,
    BuyerInfoDetailsComponent,
    SmsMarketingComponent,
    CreateMarketingSmsComponent,
    MonthlyInvoiceComponent,
    ReservationSalesComponent,
    TransactionsDetailComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(reportRoutes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class ReportModule { }
